import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';
import { getCmsClusters, getCmsPosts } from '../data/blogData';

// Blog index section for posts synced from the shared CMS, grouped by topic cluster
// (pillar guide first). Renders nothing until the CMS has published posts.
const CmsGuideList = () => {
  const posts = getCmsPosts();
  if (!posts.length) return null;

  const clusters = getCmsClusters().filter(c => posts.some(p => p.cluster?.slug === c.slug));

  return (
    <div className="mt-16 pt-16 border-t border-gray-200">
      <h2 className="text-3xl font-bold text-gray-900 mb-3">Construction Cost Guides</h2>
      <p className="text-gray-600 mb-10 max-w-3xl">
        In-depth guides for owners and developers on estimating, budgeting and controlling construction costs.
      </p>
      {clusters.map(cluster => {
        const items = posts
          .filter(p => p.cluster?.slug === cluster.slug)
          .sort((a, b) => (a.articleType === 'pillar' ? -1 : b.articleType === 'pillar' ? 1 : 0));
        return (
          <section key={cluster.slug} id={`topic-${cluster.slug}`} className="mb-12">
            <h3 className="text-xl font-bold text-gray-900 mb-5">{cluster.name}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map(post => (
                <Link key={post.slug} to={`/blog/${post.slug}`} className="group block">
                  <div className={`bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 border h-full p-6 ${post.articleType === 'pillar' ? 'border-blue-300' : 'border-gray-200 hover:border-blue-300'}`}>
                    {post.articleType === 'pillar' && (
                      <span className="inline-block text-xs font-semibold uppercase tracking-wider text-blue-700 bg-blue-50 px-2 py-1 rounded mb-3">
                        Complete guide
                      </span>
                    )}
                    <h4 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors line-clamp-2">
                      {post.title}
                    </h4>
                    <p className="text-gray-600 mb-4 leading-relaxed line-clamp-3 text-sm">{post.excerpt}</p>
                    <div className="flex items-center justify-between text-xs text-gray-500">
                      <span className="flex items-center"><Clock className="mr-1" size={14} />{post.readingMinutes} min read</span>
                      <span className="flex items-center text-blue-600 font-semibold text-sm">
                        Read <ArrowRight className="ml-1 transform group-hover:translate-x-1 transition-transform" size={14} />
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
};

export default CmsGuideList;
